<div class="login-container row">
  <div class="col-lg-4 col-md-12 col-12 left-section">
    <div class="logo-section text-center col-xs-hidden">
      <div class="login-logo text-center py-5">
        <img src="assets/images/bas-logo.svg" class="img-responsive" alt="BAS" style="max-width: 80px" />
      </div>

      <h2 class="logo-title">Biometric Authentication System</h2>
      <p class="my-lg-4 my-4 logo-desc">
        Platform to enroll each associate/ workforce entering organization
        through manpower agencies to verify their eligibility.
      </p>
      <img src="assets/images/bas-login-img.svg" class="img-responsive" alt="BAS" />
    </div>
  </div>
  <div class="col-lg-8 col-md-12 col-12 login-wrapper" style="
      background-image: url('../../../assets/images/bg-3.jpg');
      background-position: center;
    ">
    <div class="login-section">
      <mat-card class="login-card">
        <form class="login-form" [formGroup]="otpForm" (submit)="otpSubmit()" autocomplete="off">
          <div>
            <img src="assets/images/bas-verify-icon.webp" class="img-responsive" alt="BAS" />
          </div>
          <div class="form-group">
            <label class="form-title" for="signin">Two Step Verification</label>
            <p class="login-info">
              Enter the verification code we sent to <br /><b>{{
              userMobile
            }}</b>
          </p>
        </div>
        @if (show) {
          <div class="text-start mb-1">
            <p class="digit">Your OTP is : {{ otpfor ? otpfor : "---" }}</p>
          </div>
        }
        <div class="text-start mb-1">
          <label class="digit" for="digit">Type your 6 digit security code
          </label>
        </div>
        <div class="otp-input">
          <input #otp1 class="form-control" formControlName="otp1" type="text" autocomplete="off" autofocus value=""
            (keypress)="onClick($event, 'otp1')" maxlength="1" required />

            <input #otp2 class="form-control" formControlName="otp2" type="text" autocomplete="off" value=""
              (keypress)="onClick($event, 'otp2')" maxlength="1" required />

              <input #otp3 class="form-control" formControlName="otp3" type="text" autocomplete="off" value=""
                (keypress)="onClick($event, 'otp3')" maxlength="1" required />

                <input #otp4 class="form-control" formControlName="otp4" type="text" autocomplete="off" value=""
                  (keypress)="onClick($event, 'otp4')" maxlength="1" required />

                  <input #otp5 class="form-control" formControlName="otp5" type="text" autocomplete="off" value=""
                    (keypress)="onClick($event, 'otp5')" maxlength="1" required />

                    <input #otp6 class="form-control" formControlName="otp6" type="text" autocomplete="off" value=""
                      (keypress)="onClick($event, 'otp6')" maxlength="1" required />
                    </div>
                    <div class="form-actions text-center">
                      <button type="submit" class="login-submit" [ngClass]="otpForm.valid ? 'hoverEffect' : ''" name="submit"
                        [disabled]="otpForm.invalid">
                        <span>Submit</span>
                      </button>
                    </div>
                    <div>
                      @if (!showTimer) {
                        <p class="resend-text">
                          Didn’t get the code?
                          <a class="resend" (click)="resendOTP()">Resend</a>
                        </p>
                      }
                      @if (showTimer) {
                        <p class="resend-display">
                          Resend OTP in <span>{{ resendTimer }}</span>
                        </p>
                      }
                    </div>
                  </form>
                </mat-card>
              </div>
            </div>
          </div>